(function () {
  'use strict';

  var root = document.getElementById('mrj-store-page');
  if (!root || root.dataset.mrjStoreInitialized === 'true') return;
  root.dataset.mrjStoreInitialized = 'true';

  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var videoMilestones = new WeakMap();
  var pendingEvents = [];
  var publishAttempts = 0;

  function createEventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'mrj-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function sendToShopify(eventName, payload) {
    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        var result = window.Shopify.analytics.publish(eventName, payload);
        if (result && typeof result.catch === 'function') result.catch(function () {});
        return true;
      }
    } catch (error) {
      // Analytics must never interrupt a customer action.
    }

    return false;
  }

  function flushPendingEvents() {
    publishAttempts += 1;
    pendingEvents = pendingEvents.filter(function (entry) {
      return !sendToShopify(entry.name, entry.payload);
    });

    if (!pendingEvents.length) {
      publishAttempts = 0;
      return;
    }

    if (pendingEvents.length && publishAttempts < 20) {
      window.setTimeout(flushPendingEvents, 250);
    }
  }

  function publish(eventName, eventData) {
    var payload = Object.assign({
      event_id: createEventId(),
      page_type: 'store',
      page_path: window.location.pathname
    }, eventData || {});

    if (!sendToShopify(eventName, payload)) {
      pendingEvents.push({ name: eventName, payload: payload });
      if (pendingEvents.length === 1) window.setTimeout(flushPendingEvents, 250);
    }

    window.dispatchEvent(new CustomEvent('mrj:store-analytics', {
      detail: { name: eventName, data: payload }
    }));
  }

  function actionEventName(action) {
    var events = {
      directions: 'mrj:store_directions',
      call: 'mrj:store_call',
      whatsapp: 'mrj:store_whatsapp',
      shop_online: 'mrj:store_shop_online'
    };

    return events[action];
  }

  function toggleVideoForButton(button) {
    var videoScope = button.closest('[data-mrj-video-scope]');
    var scopedVideo = visibleVideoInScope(videoScope);
    if (!scopedVideo) return;

    hydrateVideo(scopedVideo);
    if (scopedVideo.paused) {
      scopedVideo.play().then(function () {
        updateVideoButton(videoScope, false);
      }).catch(function () {
        updateVideoButton(videoScope, true);
      });
    } else {
      scopedVideo.pause();
      updateVideoButton(videoScope, true);
    }
  }

  root.addEventListener('pointerup', function (event) {
    var videoToggle = event.target.closest('[data-mrj-video-toggle]');
    if (!videoToggle || !root.contains(videoToggle)) return;

    videoToggle.dataset.mrjPointerToggle = String(Date.now());
    toggleVideoForButton(videoToggle);
  }, true);

  root.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var videoToggle = event.target.closest('[data-mrj-video-toggle]');
    if (!videoToggle || !root.contains(videoToggle)) return;

    event.preventDefault();
    toggleVideoForButton(videoToggle);
  }, true);

  root.addEventListener('click', function (event) {
    var videoToggle = event.target.closest('[data-mrj-video-toggle]');
    if (videoToggle && root.contains(videoToggle)) {
      var lastPointerToggle = Number(videoToggle.dataset.mrjPointerToggle || 0);
      if (Date.now() - lastPointerToggle > 500) toggleVideoForButton(videoToggle);
      return;
    }

    var actionLink = event.target.closest('[data-mrj-store-action]');
    if (!actionLink || !root.contains(actionLink)) return;

    var action = actionLink.dataset.mrjStoreAction;
    var eventName = actionEventName(action);
    if (!eventName) return;

    publish(eventName, {
      action: action,
      placement: actionLink.dataset.mrjPlacement || 'unknown',
      destination: actionLink.dataset.mrjDestination || '',
      collection_handle: actionLink.dataset.mrjCollectionHandle || ''
    });
  }, true);

  publish('mrj:store_page_view', {
    placement: 'page',
    destination: 'visit_our_store'
  });

  function hydrateVideo(video) {
    if (!video || video.dataset.mrjHydrated === 'true') return;

    Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    video.dataset.mrjHydrated = 'true';
    video.load();
  }

  function updateVideoButton(scope, isPaused) {
    var button = scope && scope.querySelector('[data-mrj-video-toggle]');
    if (!button) return;

    button.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
    button.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');
  }

  function visibleVideoInScope(scope) {
    var videos = scope ? scope.querySelectorAll('[data-mrj-deferred-video]') : [];
    for (var index = 0; index < videos.length; index += 1) {
      if (videos[index].getClientRects().length > 0) return videos[index];
    }
    return videos[0] || null;
  }

  function trackVideoProgress(video, milestone) {
    var tracked = videoMilestones.get(video) || {};
    if (tracked[milestone]) return;
    tracked[milestone] = true;
    videoMilestones.set(video, tracked);

    publish('mrj:store_video_progress', {
      placement: video.dataset.mrjPlacement || 'gallery',
      media_id: video.dataset.mrjMediaId || '',
      milestone: milestone === 0 ? 'start' : String(milestone),
      progress_percent: milestone
    });
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-mrj-deferred-video]'), function (video) {
    video.addEventListener('canplay', function () {
      video.classList.add('is-ready');
    }, { once: true });

    video.addEventListener('play', function () {
      trackVideoProgress(video, 0);
      updateVideoButton(video.closest('[data-mrj-video-scope]'), false);
    });

    video.addEventListener('pause', function () {
      updateVideoButton(video.closest('[data-mrj-video-scope]'), true);
    });

    video.addEventListener('timeupdate', function () {
      if (!video.duration || !isFinite(video.duration)) return;
      var percent = (video.currentTime / video.duration) * 100;
      [25, 50, 75].forEach(function (milestone) {
        if (percent >= milestone) trackVideoProgress(video, milestone);
      });
      // Looping videos do not consistently emit `ended`, so capture completion
      // just before the browser seeks back to the beginning.
      if (percent >= 98) trackVideoProgress(video, 100);
    });

    video.addEventListener('ended', function () {
      trackVideoProgress(video, 100);
    });
  });

  if ('IntersectionObserver' in window && !motionQuery.matches) {
    var videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          hydrateVideo(video);
          if (video.dataset.mrjAutoplay === 'true') video.play().catch(function () {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { rootMargin: '280px 0px', threshold: 0.08 });

    Array.prototype.forEach.call(root.querySelectorAll('[data-mrj-deferred-video]'), function (video) {
      videoObserver.observe(video);
    });
  }

  function timeToMinutes(time) {
    var parts = String(time || '').split(':');
    if (parts.length !== 2) return null;
    var hours = Number(parts[0]);
    var minutes = Number(parts[1]);
    if (!isFinite(hours) || !isFinite(minutes)) return null;
    return (hours * 60) + minutes;
  }

  function formatTime(time) {
    var minutes = timeToMinutes(time);
    if (minutes === null) return time;
    var hours = Math.floor(minutes / 60);
    var suffix = hours >= 12 ? 'pm' : 'am';
    var displayHours = hours % 12 || 12;
    var displayMinutes = minutes % 60;
    return displayHours + (displayMinutes ? ':' + String(displayMinutes).padStart(2, '0') : '') + suffix;
  }

  function updateStoreStatus(status) {
    var timezone = status.dataset.timezone || 'Asia/Kolkata';
    var parts;

    try {
      parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());
    } catch (error) {
      status.textContent = 'View today\'s store hours below';
      return;
    }

    var dateParts = {};
    parts.forEach(function (part) {
      dateParts[part.type] = part.value;
    });

    var isSunday = dateParts.weekday === 'Sun';
    var openTime = isSunday ? status.dataset.sundayOpen : status.dataset.weekdayOpen;
    var closeTime = isSunday ? status.dataset.sundayClose : status.dataset.weekdayClose;
    var openMinutes = timeToMinutes(openTime);
    var closeMinutes = timeToMinutes(closeTime);
    var currentMinutes = (Number(dateParts.hour) * 60) + Number(dateParts.minute);

    if (openMinutes === null || closeMinutes === null) {
      status.textContent = 'View today\'s store hours below';
      return;
    }

    var isOpen = currentMinutes >= openMinutes && currentMinutes < closeMinutes;
    status.dataset.open = String(isOpen);

    if (isOpen) {
      status.textContent = 'Open now · Until ' + formatTime(closeTime);
    } else if (currentMinutes < openMinutes) {
      status.textContent = 'Closed · Opens today at ' + formatTime(openTime);
    } else {
      var tomorrowIsSunday = dateParts.weekday === 'Sat';
      var tomorrowOpen = tomorrowIsSunday ? status.dataset.sundayOpen : status.dataset.weekdayOpen;
      status.textContent = 'Closed · Opens tomorrow at ' + formatTime(tomorrowOpen);
    }
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-mrj-store-status]'), updateStoreStatus);

  Array.prototype.forEach.call(root.querySelectorAll('[data-mrj-map-load]'), function (button) {
    button.addEventListener('click', function () {
      var frame = button.closest('[data-mrj-map-frame]');
      if (!frame || frame.classList.contains('is-loaded')) return;

      var source = frame.dataset.mapSrc;
      if (!source) return;

      var iframe = document.createElement('iframe');
      iframe.src = source;
      iframe.title = frame.dataset.mapTitle || 'Map showing the MRJewels store';
      iframe.loading = 'lazy';
      iframe.referrerPolicy = 'no-referrer-when-downgrade';
      iframe.allowFullscreen = true;
      frame.appendChild(iframe);
      frame.classList.add('is-loaded');
    });
  });

  var allowedUtmFields = {
    utm_source: 'source',
    utm_medium: 'medium',
    utm_campaign: 'campaign'
  };
  var query = new URLSearchParams(window.location.search);
  Object.keys(allowedUtmFields).forEach(function (parameter) {
    var value = query.get(parameter);
    if (!value) return;
    var input = root.querySelector('[data-mrj-utm="' + allowedUtmFields[parameter] + '"]');
    if (input) input.value = value.slice(0, 100);
  });

  Array.prototype.forEach.call(root.querySelectorAll('.mrj-store-form__form'), function (form) {
    var successKey = 'mrj-store-lead:' + window.location.pathname + ':' + form.id;
    var requiredFields = Array.prototype.slice.call(form.querySelectorAll('[data-mrj-required]'));
    var errorSummary = form.querySelector('[data-mrj-form-error-summary]');

    function fieldErrorElement(field) {
      var errorId = field.getAttribute('aria-describedby');
      return errorId ? document.getElementById(errorId) : null;
    }

    function validationMessage(field) {
      if (!String(field.value || '').trim()) {
        return field.dataset.mrjRequiredMessage || 'Please complete this field.';
      }
      if (field.type === 'email' && !field.validity.valid) {
        return 'Please enter a valid email address.';
      }
      return '';
    }

    function validateField(field) {
      var message = validationMessage(field);
      var errorElement = fieldErrorElement(field);
      field.setAttribute('aria-invalid', message ? 'true' : 'false');
      if (errorElement) {
        errorElement.textContent = message;
        errorElement.hidden = !message;
      }
      return !message;
    }

    requiredFields.forEach(function (field) {
      field.addEventListener('invalid', function () {
        validateField(field);
        if (errorSummary) errorSummary.hidden = false;
      });
      field.addEventListener('blur', function () {
        validateField(field);
      });
      field.addEventListener('input', function () {
        if (field.getAttribute('aria-invalid') === 'true') validateField(field);
      });
    });

    form.addEventListener('submit', function (event) {
      try {
        window.sessionStorage.removeItem(successKey);
      } catch (error) {}

      var firstInvalid = null;
      requiredFields.forEach(function (field) {
        if (!validateField(field) && !firstInvalid) firstInvalid = field;
      });

      if (firstInvalid) {
        event.preventDefault();
        if (errorSummary) errorSummary.hidden = false;
        firstInvalid.focus();
        return;
      }

      if (errorSummary) errorSummary.hidden = true;
    });

    var success = form.parentElement.querySelector('[data-mrj-form-success]');
    if (!success) return;

    window.requestAnimationFrame(function () {
      success.focus();
    });

    try {
      if (window.sessionStorage.getItem(successKey) === 'sent') return;
      window.sessionStorage.setItem(successKey, 'sent');
    } catch (error) {}

    publish('mrj:store_form_success', {
      placement: 'plan_visit_form',
      destination: 'shopify_contact'
    });
  });

  var focusableFormSelector = '.mrj-store-form__form input, .mrj-store-form__form select, .mrj-store-form__form textarea';
  root.addEventListener('focusin', function (event) {
    if (event.target.matches(focusableFormSelector)) {
      document.body.classList.add('mrj-store-keyboard-open');
    }
  });
  root.addEventListener('focusout', function () {
    window.setTimeout(function () {
      if (!root.querySelector('.mrj-store-form__form :focus')) {
        document.body.classList.remove('mrj-store-keyboard-open');
      }
    }, 80);
  });

  var cookieBanner = document.querySelector('.cookies-banner');
  if (cookieBanner && 'MutationObserver' in window) {
    var updateCookieBannerState = function () {
      document.body.classList.toggle(
        'mrj-store-consent-open',
        window.getComputedStyle(cookieBanner).display !== 'none'
      );
    };
    new MutationObserver(updateCookieBannerState).observe(cookieBanner, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
    updateCookieBannerState();
  }

  var dialog = root.querySelector('[data-mrj-gallery-dialog]');
  var galleryItems = Array.prototype.slice.call(root.querySelectorAll('[data-mrj-gallery-item]'));
  if (dialog && galleryItems.length) {
    var dialogImage = dialog.querySelector('[data-mrj-gallery-dialog-image]');
    var dialogCaption = dialog.querySelector('[data-mrj-gallery-dialog-caption]');
    var currentGalleryIndex = 0;
    var lastGalleryTrigger = null;

    function renderGalleryItem(index) {
      currentGalleryIndex = (index + galleryItems.length) % galleryItems.length;
      var item = galleryItems[currentGalleryIndex];
      dialogImage.src = item.dataset.fullImage;
      dialogImage.alt = item.dataset.alt || '';
      dialogCaption.textContent = item.dataset.caption || '';
      dialogCaption.hidden = !item.dataset.caption;
    }

    galleryItems.forEach(function (item, index) {
      item.addEventListener('click', function () {
        lastGalleryTrigger = item;
        renderGalleryItem(index);
        dialog.showModal();
      });
    });

    dialog.querySelector('[data-mrj-gallery-close]').addEventListener('click', function () {
      dialog.close();
    });
    dialog.querySelector('[data-mrj-gallery-prev]').addEventListener('click', function () {
      renderGalleryItem(currentGalleryIndex - 1);
    });
    dialog.querySelector('[data-mrj-gallery-next]').addEventListener('click', function () {
      renderGalleryItem(currentGalleryIndex + 1);
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        dialog.close();
        return;
      }
      if (event.key === 'ArrowLeft') renderGalleryItem(currentGalleryIndex - 1);
      if (event.key === 'ArrowRight') renderGalleryItem(currentGalleryIndex + 1);
    });
    dialog.addEventListener('close', function () {
      dialogImage.removeAttribute('src');
      if (lastGalleryTrigger) lastGalleryTrigger.focus();
    });
  }

  Array.prototype.forEach.call(root.querySelectorAll('a[href*="/collections/"]'), function (link) {
    if (link.hasAttribute('data-mrj-store-action')) return;
    var match = link.getAttribute('href').match(/\/collections\/([^/?#]+)/);
    link.dataset.mrjStoreAction = 'shop_online';
    link.dataset.mrjPlacement = 'collection_section';
    link.dataset.mrjDestination = 'collection';
    if (match) link.dataset.mrjCollectionHandle = match[1];
  });
})();
